<template>
  <Form @submit="onSubmit" :validation-schema="schema">
    <div class="spa">
      <div class="search">
        <div class="booking-container-n">
          <div class="container">
            <div class="row mb-5">
              <div class="col-xl-24 mb-3 text-center">
                <h3 class="form-group-title">When would you like to book?</h3>
              </div>
              <div class="col-24">
                <div class="row justify-content-center">
                  <div class="mb-3 col-20 col-lg-12 mb-lg-0">
                    <v-date-picker class="inline-block h-full" v-model="date" v-bind:min-date="minDate" v-bind:locale="locale">
                      <template v-slot="{ inputValue, togglePopover }">
                        <div class="flex items-center" @click="togglePopover()">
                          <input v-bind:value="inputValue" class="form-control search-date calendar" readonly />
                        </div>
                      </template>
                    </v-date-picker>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-5">
              <div class="col-xl-24 mb-3 text-center">
                <h3>Number of guests:</h3>
              </div>

              <div class="col-xl-24 d-flex justify-content-center">
                <ul class="rad-btn-list">
                  <li>
                    <input id="rc1" type="radio" value="1" name="rc" v-model="guestCount" />
                    <label for="rc1">1</label>
                  </li>
                  <li>
                    <input id="rc2" type="radio" value="2" name="rc" v-model="guestCount" />
                    <label for="rc2">2</label>
                  </li>
                  <li>
                    <input id="rc3" type="radio" value="3" name="rc" v-model="guestCount" />
                    <label for="rc3">3</label>
                  </li>
                  <li>
                    <input id="rc4" type="radio" value="4" name="rc" v-model="guestCount" />
                    <label for="rc4">4</label>
                  </li>
                  <li>
                    <input id="rc5" type="radio" value="0" name="rc" v-model="guestCount" />
                    <label for="rc5">5+</label>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="row" v-if="guestCount == 0">
            <div class="col mb-5 d-flex justify-content-center">
              <div class="guests-exceeded">
                <p>
                  For bookings of 4 guests or more please contact a member of the Spa team by calling
                  <a href="tel:01325729999">01325 729999</a> or click below to submit a spa booking <a href="/spa-wellness/spa-enquiry/">enquiry</a>.
                </p>
              </div>
            </div>
          </div>
          <!--<div  v-else>


                        <div class="row mb-5 justify-content-center">
                            <div class="col-24 col-md-16 ">
                                <div class="form-group">
                                    <div class="title-wrapper">
                                        <h3 class="form-group-title">Got a code or voucher?</h3>
                                        <button class="help mb-2" type="button" v-on:click="onVoucherModalToggle()">Help</button>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Enter code" v-model="code" />
                                </div>
                            </div>
                            <div class="col-24 d-block d-md-none mt-5 ">
                                <div class="form-group">
                                    <div class="title-wrapper">
                                        <h3 class="form-group-title">Got a QR code?</h3>
                                        <button class="help mb-2">Help</button>
                                    </div>
                                    <button class="btn btn--gold btn--block btn--camera">
                                        <span>
                                            Scan Code
                                        </span>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>-->
        </div>
      </div>
    </div>

    <actions-bar>
      <template v-slot:actions>
        <div class="row">
          <div class="col-12 d-flex justify-content-start">
            <button v-on:click="onBack" type="button" class="btn btn--transparent btn--back">Back</button>
          </div>
          <div class="col-12 d-flex justify-content-end" v-if="guestCount != 0">
            <button class="btn btn--slate-blue btn--continue" type="submit" v-bind:disabled="isContinueDisabled">Guest Names</button>
          </div>
        </div>
      </template>
    </actions-bar>

    <standard-modal v-if="modalVouchersVisible" v-on:close="modalVouchersVisible = false">
      <template v-slot:header>
        <h2 class="mb-md-5 mb-3">How to use Voucher Codes</h2>
      </template>
      <template v-slot:body>
        <div class="row mb-md-5 mb-3" v-for="(giftVoucher, index) in content.giftVouchers" v-bind:key="index">
          <div class="col-md-8 d-flex justify-content-center mb-md-0 mb-3">
            <div v-if="giftVoucher.Image" class="voucher-code-image">
              <span class="has-bg-image bg-full" role="img" v-bind:style="{ backgroundImage: 'url(' + giftVoucher.Image.Path + ')' }"></span>
            </div>
          </div>
          <div class="col-md-16 col-sm-18 mx-md-0 mx-auto text-md-start text-center">
            <h3>
              {{ giftVoucher.Title }}
            </h3>
            <div class="dottedborder" v-html="giftVoucher.Body"></div>
          </div>
        </div>
      </template>
    </standard-modal>
  </Form>
</template>
<script>
import ActionsBar from "@/shared/components/ActionsBar.vue";
import StandardModal from "@/shared/components/StandardModal.vue";
import Cancel from "@/shared/components/Cancel.vue";
import { Field, Form, ErrorMessage } from "vee-validate";
import { store } from "../store/index";
import moment from "moment";
import * as yup from "yup";
export default {
  name: "SpaTreatmentSearch",
  components: {
    ActionsBar,
    Cancel,
    Field,
    Form,
    ErrorMessage,
    StandardModal,
  },
  mounted() {
    store.dispatch("getConfiguration").then(() => {
      this.guestCount = this.$route.query.guests || 2;

      let innerDate = this.$route.query.d != null ? new Date(this.$route.query.d) : new Date();

      var m = moment(innerDate);
      var result = m.hour() * 60 + m.minute();

      if (result > 900) {
        this.date = moment(innerDate).add(1, "d").format("YYYY-MM-DD");
        this.minDate = moment(innerDate).add(1, "d").format("YYYY-MM-DD");
      } else {
        this.date = moment(innerDate).format("YYYY-MM-DD");
        this.minDate = moment(innerDate).format("YYYY-MM-DD");
      }
    });
  },
  computed: {
    session() {
      return store.getters.session;
    },
    configuration() {
      return store.getters.configuration;
    },
    content() {
      return this.configuration.Content.search;
    },
    isContinueDisabled() {
      return +this.guestCount == 0 && this.date == null && this.selectedSpaDay != null;
    },
  },
  data() {
    const schema = yup.object().shape({});
    return {
      schema,
      modalVouchersVisible: false,
      guestCount: 2,
      minDate: null,
      date: null,
      minDate: null,
      code: null,
      locale: "en-GB",
    };
  },
  methods: {
    onBack: function () {
      this.$router.push({
        name: "spa_type",
        params: { id: this.session.Id },
      });
    },
    onSubmit: function (values) {
      store.dispatch("clear");

      var payload = {
        guestCount: this.guestCount,
        date: moment(this.date).format("YYYY-MM-DD"),
        spaDay: this.selectedSpaDay,
        code: this.code,
      };
      store.dispatch("createSession").then((response) => {
        var id = response.Id;
        store.dispatch("setSearch", payload).then(() => {
          this.$router.push({
            name: "spa_treatment_guests",
            params: { id: this.session.Id },
          });
        });
      });
    },
    onVoucherModalToggle: function () {
      this.modalVouchersVisible = !this.modalVouchersVisible;
    },
  },
};
</script>
<style>
.spa-day-item {
  position: relative;
}

.spa-day-item h4 {
  font-size: 24px;
}

.spa-day-item .spa-day-price {
  font-size: 24px;
  font-weight: bold;
  position: absolute;
  top: 40px;
  right: 40px;
}

.spa-day-item .spa-day-body {
  margin-top: 20px;
}

.spa-day-item .spa-day-body p,
.spa-day-item .spa-day-body ul li {
  font-weight: 300;
}

.spa-day-item .spa-day-body ul li::marker {
  color: #a18f5b;
}

.spa-day-item .spa-day-price span {
  font-size: 18px;
  font-weight: 300;
}

.spa-day-item .btn {
  background-color: #eee9e7;
  padding: 15px;
  padding-left: 44px;
  position: relative;
  border: none;
}

.spa-day-item .btn:before,
.spa-day-item .btn:after {
  position: absolute;
  content: "";
  display: block;
  border-radius: 50%;
  z-index: 10;
}

.spa-day-item .btn:before {
  height: 24px;
  width: 24px;
  left: 10px;
  top: 10px;
  background: white;
}

.spa-day-item--is-selected {
  border: solid 2px #425260;
}

.spa-day-item--is-selected .btn {
  background-color: #425260;
  color: white;
}

.spa-day-item--is-selected .btn:after {
  height: 16px;
  width: 16px;
  left: 14px;
  top: 14px;
  background: #425260;
}

.voucher-code-image {
  position: relative;
  height: 196px;
  width: 251px;
}

@media (max-width: 575px) {
  .spa-day-item .spa-day-price {
    position: relative;
    top: unset;
    right: unset;
  }

  .spa-day-item h4 {
    max-width: unset;
  }
}

.guests-exceeded p {
  font-size: 18px;
  max-width: 600px;
  text-align: center;
}

.guests-exceeded a {
  font-weight: bold;
}
</style>
